import {
  AgxSpacer,
  AgxTypography,
  AgxButton,
  AgxTextInput,
  Icon_MagnifyingGlass,
  Icon_PlusOutline,
  AgxRow,
} from '@urbanx/agx.ui-components2';

interface AgenciesHeaderProps {
  totalCount?: number;
  searchText: string;
  onSearchTextChange: (value: string) => void;
  onAddNewAgency: () => void;
}

const AgenciesHeader = ({
  totalCount,
  searchText,
  onSearchTextChange,
  onAddNewAgency,
}: AgenciesHeaderProps) => {
  return (
    <AgxSpacer
      className="AgenciesHeader"
      direction="horizontal"
      padding={{ top: 'sm', bottom: 'sm', left: 'md', right: 'md' }}
      gap="sm"
      fill
      contentAlignment="center"
      contentJustification="space-between"
    >
      <AgxSpacer direction="horizontal">
        <AgxTypography id="tasksNumber" type="body_ui" size="medium" style={{ flexShrink: 0 }}>
          <AgxTypography id="tasksNumber" type="body_ui" size="medium" color="var(--text-primary)">
            {`${totalCount ? `${totalCount}` : ''}`}
            {`${totalCount && totalCount > 1 ? ` Agencies` : totalCount && totalCount > 0 ? ' Agency' : 'No matching agency found'}`}
          </AgxTypography>
        </AgxTypography>
      </AgxSpacer>

      <AgxSpacer
        direction="horizontal"
        gap="sm"
        contentAlignment="center"
        contentJustification="end"
      >
        <AgxRow gap={'none'}>
          <AgxTextInput
            id="searchTxt"
            stretch
            label=""
            defaultValue={searchText}
            onChange={(value) => onSearchTextChange(value)}
            placeholder="Search"
            border="rounded"
            leftIcon={<Icon_MagnifyingGlass />}
            type={'text'}
            optionalText=""
          />
        </AgxRow>
        <AgxRow gap={'none'}>
          <AgxButton
            id={'btn-newAgency'}
            text="New Agency"
            size="medium"
            variant={'dark'}
            onClick={onAddNewAgency}
            rightIcon={<Icon_PlusOutline color="var(--text-white)" height={10} width={10} />}
          />
        </AgxRow>
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default AgenciesHeader;
